export default function LiveIndicator({ status, compact = false }) {
  const isOpen = status === "open";
  const isConnecting = status === "connecting";

  const dotColor = isOpen ? "#00FFA3" : "#FF2A2A";
  const borderColor = isOpen ? "border-[#00FFA3]/40" : "border-[#FF2A2A]/40";
  const bgColor = isOpen ? "bg-[#025939]/30" : "bg-[#590909]/30";
  const label = isOpen ? "Live" : isConnecting ? "Connecting…" : "Reconnecting…";

  if (compact) {
    return (
      <span
        className={`cb-hud-chip flex items-center gap-1.5 px-2 py-1.5 ${borderColor} ${bgColor}`}
        data-testid="ws-status-indicator"
        data-status={status}
        title={label}
      >
        <span className="relative flex items-center justify-center w-2.5 h-2.5">
          <span
            className="absolute inset-0 rounded-full opacity-70 cb-pulse-strong"
            style={{ background: dotColor }}
          />
          <span
            className="relative w-1.5 h-1.5 rounded-full"
            style={{ background: dotColor, boxShadow: `0 0 8px ${dotColor}` }}
          />
        </span>
      </span>
    );
  }

  return (
    <div
      className={`cb-hud-chip flex items-center gap-3 px-4 py-2 ${borderColor} ${bgColor}`}
      data-testid="ws-status-indicator"
      data-status={status}
    >
      <span className="relative flex items-center justify-center w-3 h-3">
        <span
          className="absolute inset-0 rounded-full opacity-70 cb-pulse-strong"
          style={{ background: dotColor }}
        />
        <span
          className="relative w-2 h-2 rounded-full"
          style={{ background: dotColor, boxShadow: `0 0 10px ${dotColor}` }}
        />
      </span>
      <span className="font-mono-tac text-[10px] uppercase tracking-[0.28em] text-white">
        {label}
      </span>
    </div>
  );
}
